
export default class{
    static write(msg){
        if (typeof window !== 'undefined') {
            console.log(msg);
        }
    }
    static log(msg) {
        if (typeof window !== 'undefined') {
            console.log(msg);
        }
    }
}
